import gql from 'graphql-tag';

export const GET_COUPONS = gql`
  query GetCoupons {
    getCoupons {
      _id
      code
      discountType
      discountValue
      expirationDate
      status
      usageLimit
      usedCount
      packages {
        _id
        description
        type
      }
    }
  }
`;
